import { useMemo } from 'react'

function decodeBase64Value(value: string): string {
  const normalized = value
    .trim()
    .replace(/ /g, '+')
    .replace(/-/g, '+')
    .replace(/_/g, '/')
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=')
  const binary = window.atob(padded)
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0))

  return new TextDecoder('utf-8').decode(bytes)
}

function resolveQrCodeDataResult(): string {
  if (typeof window === 'undefined') return 'null'

  const encodedData = new URLSearchParams(window.location.search).get('data') || ''
  if (!encodedData.trim()) return 'null'

  try {
    const decodedData = decodeBase64Value(encodedData)
    const parsedData = JSON.parse(decodedData)
    return JSON.stringify(parsedData, null, 2)
  } catch {
    return 'null'
  }
}

export function QrCodeDataResultView() {
  const result = useMemo(() => resolveQrCodeDataResult(), [])

  return (
    <pre
      style={{
        margin: 0,
        padding: 8,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {result}
    </pre>
  )
}
